<template>
    <v-row align="center" class="list px-3 mx-auto">
      <v-col cols="12" md="8">
        <v-text-field v-model="title" label="Search by Title"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-btn small @click="searchTitle">
          Search
        </v-btn>
      </v-col>

      <v-col cols="12" sm="12">
        <v-card class="mx-auto" tile>
          <v-card-title>Eventos</v-card-title>

          <v-data-table
            :headers="headers"
            :items="categorias"
            disable-pagination
            :hide-default-footer="true"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="editEventos(item.id)">mdi-pencil</v-icon>
              <v-icon small @click="deleteEventos(item.id)">mdi-delete</v-icon>
            </template>
          </v-data-table>

          <v-card-actions v-if="categorias.length > 0">
            <v-btn small color="error" @click="removeAllEventos">
              Remove All
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </template>

  <script>
    import categoriasDataService from "../../../services/categoriasDataService";
  export default {
    name: "categorias-all",
    data() {
      return {
        categorias: [],
        title: "",
        headers: [
          { text: "Title", align: "start", sortable: false, value: "title" },
          { text: "Description", value: "description", sortable: false },
          { text: "Status", value: "status", sortable: false },
          { text: "Actions", value: "actions", sortable: false },
        ],
      };
    },
    methods: {
      retrieveEventos() {
        categoriasDataService.getAll()
          .then((response) => {
            this.categorias = response.data.map(this.getDisplayEventos);
            console.log(response.data);
          })
          .catch((e) => {
            console.log(e);
          });
      },

      refreshList() {
        this.retrieveEventos();
      },

      removeAllEventos() {
        categoriasDataService.deleteAll()
          .then((response) => {
            console.log(response.data);
            this.refreshList();
          })
          .catch((e) => {
            console.log(e);
          });
      },

      searchTitle() {
        categoriasDataService.findByTitle(this.title)
          .then((response) => {
            this.categorias = response.data.map(this.getDisplayEventos);
            console.log(response.data);
          })
          .catch((e) => {
            console.log(e);
          });
      },

      editEventos(id) {
        this.$router.push({ name: "categorias-details", params: { id: id } });
      },

      deleteEventos(id) {
        categoriasDataService.delete(id)
          .then(() => {
            this.refreshList();
          })
          .catch((e) => {
            console.log(e);
          });
      },

      getDisplayEventos(categorias) {
        return {
          id: categorias.id,
          title: categorias.title.length > 30 ? categorias.title.substr(0, 30) + "..." : categorias.title,
          description: categorias.description.length > 30 ? categorias.description.substr(0, 30) + "..." : categorias.description,
          status: categorias.published ? "Published" : "Pending",
        };
      },
    },
    mounted() {
      this.retrieveEventos();
    },
  };
  </script>

  <style>
  .list {
    max-width: 750px;
  }
  </style>